<template>
	<label v-if="label" class="label">
		<span class="fake-label">{{label}} <span v-if="required">*</span></span>
		<slot :required="required"></slot>
	</label>
</template>

<script>
export default {
	name: 'VLabeledGroup',
	props: {
		required: {
			type: Boolean,
			default: false
		},
		label: {
			type: String
		}
	}
}
</script>

<style scoped lang="scss">
.label {
	display: block;
	margin-bottom: 15px;
}

.fake-label {
	text-transform: capitalize;
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	color: #FFFFFFBF;
	margin-bottom: 4px;
	text-align: left;
	display: block;

	span {
		color: red
	}
}
</style>
